import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "../src/locales/en/index";
import translationHE from "../src/locales/he/index";
import translationAR from "../src/locales/ar/index";
import translationFR from "../src/locales/fr/index";
import translationRU from "../src/locales/ru/index";
import { IS_CLIENT_SERVER } from "./config/appConfig";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const fallbackLng = ["he"];
const availableLanguages = ["ar", "he", "en", "fr", "ru" ];// "fr", "ru"

const resources = {
  en: translationEN,
  he: translationHE,
  ar: translationAR,
  fr: translationFR,
  ru: translationRU,
};

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: "he",
    detection: {
      checkWhitelist: true // options for language detection
    },
    debug: false,
    lng: IS_CLIENT_SERVER ? "he" : "en", // IS_CLIENT_SERVER? "he" :
    whitelist: availableLanguages,
    supportedLngs: availableLanguages,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

export default i18n;
